import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import ClientContext from 'features/common/ui/ClientContext'
import { Client } from 'features/common/utils/clientParameter'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import BuilderLoginPrompt from './BuilderPublic/BuilderLoginPrompt'

const BuilderPrivate = lazy(() => import('./BuilderPrivate/BuilderPrivate'))
const BuilderPublic = lazy(() => import('./BuilderPublic/BuilderPublic'))
const BuilderViewer = lazy(() => import('./BuilderPublic/BuilderViewer'))
const CustomBuilderMapNotFoundError = lazy(() => import('features/errors/ui/CustomBuilderMapNotFoundError'))

const routes = [
  {
    path: 'builder',
    element: <ClientContext client={Client.Builder} />,
    children: [
      {
        index: true,
        element: (
          <LazyLoad>
            <AuthenticatedRoute element={<BuilderPrivate />} />
          </LazyLoad>
        )
      },
      {
        path: ':mapId',
        element: (
          <LazyLoad>
            <AuthenticatedRoute element={<BuilderPrivate />} prompt={<BuilderLoginPrompt />} />
          </LazyLoad>
        )
      }
    ]
  },
  {
    path: 'builder/error/404',
    element: (
      <LazyLoad>
        <CustomBuilderMapNotFoundError />
      </LazyLoad>
    )
  },
  {
    //  This route to public 'map/**' */ is managed by infra in the specific firebase & CSP configuration
    //  Double check if a change in the path is needed
    path: 'map',
    element: <ClientContext client={Client.Builder} />,
    children: [
      {
        path: ':mapId',
        element: (
          <LazyLoad>
            <BuilderPublic />
          </LazyLoad>
        )
      }
    ]
  },
  {
    path: 'viewer',
    element: (
      <AuthenticatedRoute
        element={<ClientContext client={Client.Builder} />}
        prompt={<BuilderLoginPrompt />}
        allowGuestAccess
      />
    ),
    children: [
      {
        path: ':mapId',
        element: (
          <LazyLoad>
            <BuilderViewer />
          </LazyLoad>
        )
      }
    ]
  }
]
export default routes
